<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = ["data-id", "data-dragging", "data-disabled"];
const _hoisted_2 = {
  key: 0,
  class: "magic-draggable__overlay"
};
import { ref, computed, toValue, toRefs } from "vue";
import { defu } from "defu";
import { useDraggableDrag } from "../composables/private/useDraggableDrag";
import { useDraggableState } from "../composables/private/useDraggableState";
import { defaultOptions } from "../utils/defaultOptions";
export default /* @__PURE__ */ _defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "MagicDraggable",
  props: {
    id: { type: null, required: true },
    options: { type: Object, required: false, default: () => ({}) }
  },
  setup(__props) {
    const mappedOptions = defu(__props.options, defaultOptions);
    const elRef = ref(void 0);
    const wrapperRef = ref(void 0);
    const { initializeState } = useDraggableState(__props.id);
    const state = initializeState();
    const { dragging } = toRefs(state);
    const disabled = computed(() => {
      if (__props.options.disabled === void 0) {
        return defaultOptions.disabled;
      } else {
        return __props.options.disabled;
      }
    });
    const { snapPoints, animation, initial, threshold, scrollLock } = mappedOptions;
    const { onPointerdown, onClick, style, hasDragged } = useDraggableDrag({
      id: __props.id,
      elRef,
      wrapperRef,
      threshold,
      snapPoints,
      animation,
      initial,
      scrollLock
    });
    function guardedPointerdown(event) {
      if (!disabled.value) {
        onPointerdown(event);
      }
    }
    function guardedClick(event) {
      if (!disabled.value) {
        onClick(event);
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _mergeProps({
        ref: "drawerRef",
        "data-id": toValue(_ctx.id),
        "data-dragging": _unref(dragging),
        "data-disabled": disabled.value,
        class: "magic-draggable"
      }, _ctx.$attrs), [
        _createElementVNode(
          "div",
          {
            ref_key: "wrapperRef",
            ref: wrapperRef,
            class: "magic-draggable__wrapper"
          },
          [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(mappedOptions).tag), {
              ref_key: "elRef",
              ref: elRef,
              class: "magic-draggable__drag",
              style: _normalizeStyle(_unref(style)),
              onPointerdown: guardedPointerdown,
              onClick: guardedClick
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default"),
                _unref(hasDragged) ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("v-if", true)
              ]),
              _: 3
              /* FORWARDED */
            }, 40, ["style"]))
          ],
          512
          /* NEED_PATCH */
        )
      ], 16, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-draggable {
  position: var(--magic-draggable-position, fixed);
  width: var(--magic-draggable-width, 100%);
  height: var(--magic-draggable-height, 100%);
  z-index: var(--magic-draggable-z-index, 999);
  inset: var(--magic-draggable-inset, 0);
  pointer-events: none;
  background: transparent;
  color: inherit;
  padding: 0;
  border: none;
}

.magic-draggable[data-disabled='true'] {
  pointer-events: none;
}

.magic-draggable__wrapper {
  width: 100%;
  height: 100%;
  display: block;
}

.magic-draggable__drag {
  cursor: grab;
  user-select: none;
  pointer-events: auto;
  position: relative;
  display: inline-flex;
  width: auto;
  height: auto;
  transform-origin: center;
  touch-action: none;
}

.magic-draggable[data-dragging='true'] .magic-draggable__drag {
  cursor: grabbing;
  user-select: none;
}

.magic-draggable[data-disabled='true'] .magic-draggable__drag {
  cursor: default;
}

.magic-draggable__overlay {
  position: absolute;
  inset: 0;
  z-index: 9999;
}
</style>
